import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function PrivacyPage() {
  return (
    <>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Last updated:</strong> July 26, 2026
      </p>

      <p>
        This Privacy Policy explains how <strong>Gatito Pirata Technologies EIRL</strong>{" "}
        collects, uses, and protects personal data processed through BrickGestor, in
        accordance with Peruvian Law N.° 29733, Ley de Protección de Datos
        Personales, its regulation approved by Supreme Decree N.° 003-2013-JUS,
        and, where applicable, other relevant international data protection
        standards.
      </p>

      <h2>1. Data controller</h2>
      <p>
        The entity responsible for the processing of your personal data (the
        "data controller") is:
      </p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        RUC: 20616175221
        <br />
        Peru
        <br />
        Email: brickgestor@gatitopirata.com
      </p>

      <h2>2. Personal data we collect</h2>
      <p>Depending on how you use BrickGestor, we may collect:</p>
      <ul>
        <li>
          Account and contact data, such as your name and email address
        </li>
        <li>
          Store data you provide, such as your store name, inventory, prices,
          and descriptions
        </li>
        <li>Billing data associated with your subscription plan</li>
        <li>
          Technical and usage data, such as browser type, IP address,
          timestamps, and pages visited
        </li>
      </ul>
      <p>
        We only collect the personal data reasonably necessary to provide the
        service. If new features require additional data in the future, we
        will inform you and request it in accordance with this Policy.
      </p>

      <h2>3. Purpose and legal basis for processing</h2>
      <p>We process your personal data to:</p>
      <ul>
        <li>Create and manage your account and your store(s)</li>
        <li>Provide, maintain, and improve the BrickGestor service</li>
        <li>Process subscription billing and payments</li>
        <li>Communicate with you about your account or the service</li>
        <li>
          Maintain the security of the platform and prevent fraud or abuse
        </li>
        <li>Comply with legal obligations</li>
      </ul>
      <p>
        In accordance with Article 5 of Law N.° 29733, we process your
        personal data on the basis of your free, prior, informed, express,
        and unequivocal consent, given when you create an account or
        otherwise use BrickGestor, except where the law allows processing
        without consent (for example, to comply with a legal obligation).
      </p>

      <h2>4. Your rights (ARCO rights)</h2>
      <p>
        As a data subject under Law N.° 29733, you have the right to:
      </p>
      <ul>
        <li>
          <strong>Access</strong> the personal data we hold about you
        </li>
        <li>
          <strong>Rectify</strong> inaccurate or incomplete data
        </li>
        <li>
          <strong>Cancel</strong> (delete) your data when it is no longer
          necessary or you withdraw your consent
        </li>
        <li>
          <strong>Oppose</strong> the processing of your data for a
          legitimate reason
        </li>
      </ul>
      <p>
        These are known as your ARCO rights. You may exercise any of them at
        any time by writing to{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
        . We will respond within the time limits established by law.
      </p>
      <p>
        If you believe your rights have not been respected, you may file a
        complaint with the Autoridad Nacional de Protección de Datos
        Personales, the Peruvian authority responsible for the Registro
        Nacional de Protección de Datos Personales (RNPDP).
      </p>

      <h2>5. International data transfers</h2>
      <p>
        Some of the service providers we use to operate BrickGestor (such as
        hosting, email, and payment processing providers) may be located
        outside Peru. When we transfer personal data internationally, we do
        so only to recipients that maintain an adequate level of protection
        or under contractual safeguards equivalent to those required by
        Article 15 of Law N.° 29733 and its regulation, and, where relevant,
        in line with other applicable international data protection
        standards.
      </p>

      <h2>6. Data retention</h2>
      <p>
        We retain your personal data for as long as your account is active or
        as needed to provide the service. When you delete your account or
        request cancellation of your data, we will delete or anonymize it
        within a reasonable period, except where we are legally required to
        retain it for longer (for example, tax or accounting obligations).
      </p>

      <h2>7. Security measures</h2>
      <p>
        We implement technical, organizational, and legal security measures
        to protect your personal data against loss, misuse, unauthorized
        access, and alteration, as required by Law N.° 29733 and its
        regulation. However, no method of transmission over the Internet or
        electronic storage is completely secure, and we cannot guarantee
        absolute security.
      </p>

      <h2>8. Cookies</h2>
      <p>
        BrickGestor uses cookies where necessary to keep you signed in and to
        remember your preferences. We do not use cookies for third-party
        advertising.
      </p>

      <h2>9. Minors</h2>
      <p>
        BrickGestor is intended for users who are at least 18 years old, as
        described in our Terms & Conditions. We do not knowingly collect
        personal data from minors.
      </p>

      <h2>10. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect
        changes in our practices or in applicable law. When we do, we will
        update the date at the top of this page.
      </p>

      <h2>11. Contact</h2>
      <p>
        If you have any questions, requests, or suggestions regarding this
        Privacy Policy or the processing of your personal data, please
        contact us at{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
        .
      </p>
    </>
  );
}
PrivacyPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default PrivacyPage;
